export type TaxDetails = {
  showPriceWithTax: boolean;
  displayTaxType: EDisplayTaxType;
};

export type Plan = {
  name: string;
  description: PlanDescription;
  title?: string;
  meterdBilling?: MeterdBilling;
  yearlyPrice?: string;
  monthlyPrice?: string;
  isFree: boolean;
};

export type MeterdBilling = {
  outline?: string;
  baseFee: string;
};

export type PlanDescription = {
  descriptionType: EPlanDescription | null;
  costumeText?: string;
  benefits: string[];
};

export enum EPlanDescription {
  /** benefits array description */
  BENEFITS = 'BENEFITS',
  /** custom paragraph description */
  CUSTOM_TEXT = 'CUSTOM_TEXT',
}

export type CurrencySettings = {
  code: string;
  symbol: string;
};

export enum EDisplayTaxType {
  NOT_APPLICABLE = 'NOT_APPLICABLE',
  VAT = 'VAT',
  GST = 'GST',
}

export enum EPaymentCycle {
  ONE_TIME = 'ONE_TIME',
  MONTHLY = 'MONTHLY',
  YEARLY = 'YEARLY',
}

export interface PricingPlansSectionOptions {
  showExternalPricingLink?: boolean;
  showNarrowPlansView?: boolean;
}
